<template>
  <div class="w-100">

    <!-- Navigation and related information START -->
    <div id="nav-info" role="navigation" class="container-fluid fixed-top w-100 px-0">
      <interview-navi :navData="pageData"></interview-navi>
    </div>
    <!-- Form Container START -->
    <div role="main" :class="{'quote-panel-open': quotePanelStatus, 'quote-panel-close': !quotePanelStatus, 'bundle' : flowType === 'bundle' || flowType === 'cabundle' || flowType === 'rabundle'}">
      <form @keydown.enter.prevent="submitted">
        <div id="form-container" class="container-fluid px-0">
          <div>
            <div id="form-headings" class="row mx-0 bg-white">
              <div class="col-12 text-left px-0">
                <!-- REQUIRED-->
                <div class="required row mx-0">
                  <div class="col-12 px-0 text-left">
                    <span class="star">*</span>Required to run carrier quotes.
                    <hr />
                  </div>
                </div>

                <!-- TOP Instruction SECTION -->
                <div class="d-flex justify-content-center mx-auto mb-1" v-if="blurbs.formtop.visible">
                  <div class="alert alert-primary my-0 py-2 w-50" role="note">
                    <div class="row no-gutters">
                      <div class="d-inline-block pr-2">
                        <img width="25px" height="25px" src="../../../../assets/info-circle-blue.svg" alt="info">
                      </div>
                      <div class="col d-inline-block my-auto smaller-font-content" v-html="blurbs.formtop.content">
                      </div>
                    </div>
                  </div>
                </div>
                <!-- TOP Instruction SECTION END -->

                <!-- POLK DATA section start -->
                <div class="row mx-0">
                  <div class="col-12 px-0">
                    <!--POLK DRIVERS-->
                    <div class="row no-gutters mt-1 mb-3"
                      v-if="this.pageData.polk_buttons && this.pageData.polk_buttons.length">
                      <div class="col-12 py-2 pl-2 bg-ltblue text-white rounded-top">
                        <div role="heading" aria-level="2">Review all POLK vehicles with the customer.</div>
                      </div>
                      <div class="col-12 py-2 shadow-sm rounded-bottom">
                        <!--POLK vehicle -->
                        <div class="d-inline-block w-100">
                          <button v-for="(pItem, pKey) in pageData.polk_buttons" :key="pKey+'_polk_btn'"
                            :id="'polk_vehicle_'+pKey" @keydown.enter.prevent.stop="updatePolkData(pItem, 'vehicle')"
                            @click="updatePolkData(pItem, 'vehicle')" class="polk-btns vd-btn btn px-3 wsn list-item"
                            tabindex="0"
                            v-bind:class="{ 'select complete': pItem.status === 'Included', 'deselect':  pItem.status === 'Excluded' }">
                            <div>
                              <icon name="car" scale="1.1" class="d-block mx-auto float-left"></icon>
                              <div class="polk-veh-lbl float-left text-left d-block pl-1">{{ pItem.label }}</div>
                              <div class="vehicle-check-polk" v-if="pItem.status === 'IncludedComplete'"></div>
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                    <!--POLK Vehicle-->
                    <!--NEW/Added Vehicle-->
                    <div class="row no-gutters mt-1">
                      <div class="col-12 py-2 pl-2 bg-ltblue text-white rounded-top">
                        <div role="heading" aria-level="2">Manually add vehicle(s) to the policy.</div>
                      </div>
                      <div class="col-12 py-2 shadow-sm rounded-bottom">
                        <!--added vehicle -->
                        <div class="d-inline-block w-100">
                          <template v-for="(ndData, ndKey) in pageData.new_buttons">
                            <button class="vd-btn btn px-3 wsn select list-item" tabindex="0"
                              :key="ndKey+'_non_add_veh'" v-if="ndData.name !== 'AddVehicle'">
                              <icon name="car" scale="1.1" class="d-block mx-auto float-left"></icon>
                              <div class="smaller-font-content polk-veh-lbl float-left text-left d-block pl-1">
                                {{ ndData.label }}</div>
                              <a href="JavaScript:void(0);"
                                @keydown.enter.prevent.stop="openRemoveModal('remove-vehicle-modal', ndData.on_click)"
                                @click.prevent="openRemoveModal('remove-vehicle-modal', ndData.on_click)" class="delete"
                                aria-label="remove vehicle" tabindex="0"
                                v-if="$store.state.buttonState.quoteSummaryData && $store.state.buttonState.quoteSummaryData.quote_status !== 'Bound'"></a>
                              <div class="check" v-if="ndData.status === 'IncludedComplete'"></div>
                            </button>
                            <button class="add-button btn btn-outline-success px-1 wsn select list-item px-3"
                              tabindex="0" :key="ndKey+'_veh_add'"
                              v-if="ndData.name === 'AddVehicle' && ndData.status !== 'Invisible' && $store.state.buttonState.quoteSummaryData && $store.state.buttonState.quoteSummaryData.quote_status !== 'Bound'"
                              @keydown.enter.prevent.stop="addNewRule(ndData, 'Vehicle')"
                              @click.prevent="addNewRule(ndData, 'Vehicle')">
                              <icon name="plus-circle" scale="1.1" class="d-block mx-auto float-left"></icon>
                              <div class="smaller-font-content polk-veh-lbl float-left text-left d-block pl-1">
                                {{ ndData.label }}</div>
                            </button>
                          </template>
                        </div>
                        <!--added vehicle-->
                        <!--ADD NEW Vehicle BUTTON-->
                      </div>
                    </div>
                    <!--NEW Vehicle-->
                  </div>
                </div>
              </div>
            </div>

            <!-- Top scroll bar START -->
            <!-- This is for the top scroll bar. It will match the width of the actual carousel -->
            <div id="carousel-vehicle-top-scrollbar" class="scrolling-wrapper pb-2 bg-white">
              <div v-for="(vitem, vkey) in pageFieldsArray" :key="vkey+'_veh_cnt'" class="cardItem col-md-3">
              </div>
            </div>
            <!-- Top scroll bar END -->

            <!-- Column headings START -->
            <div id="carousel-vehicle-headings" class="scrolling-wrapper pt-3 bg-white">
              <div v-for="(vitem, vkey) in pageFieldsArray" :key="vkey+'_veh_cnt'" class="cardItem col-md-3">
                <div v-bind:id="'vehAcc_'+vkey" class="form-row py-2 pl-3 mx-0 bg-ltblue text-white rounded-top h-100">
                  <div class="col p-0">
                    <div>
                      <div role="heading" aria-level="3">{{ getAccordianLabel(pageFieldsArray, vkey) }}</div>
                      <a href="JavaScript:void(0);"
                        @keydown.enter.prevent.stop="openRemoveModal('remove-vehicle-modal', deleteLinks[vkey].on_click)"
                        @click.prevent="openRemoveModal('remove-vehicle-modal', deleteLinks[vkey].on_click)" class="delete"
                        aria-label="remove vehicle"
                        v-if="$store.state.buttonState.quoteSummaryData && $store.state.buttonState.quoteSummaryData.quote_status !== 'Bound'"></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Column headings END -->

        </div>
        <!-- Navigation and related information END -->

        <!-- View body START -->
        <div class="container-fluid" style="margin-top: 0">
          <div id="carousel-vehicle" class="row scrolling-wrapper pb-3">
            <div v-for="(vitem, vkey) in pageFieldsArray" :key="vkey+'_veh_cnt'" class="cardItem col-md-3 mb-3">
              <div v-bind:id="'vehAccPanel_'+vkey" class="form-row mx-0 pt-3 accordPanel shadow-sm rounded-bottom">
                <div class="col-12 px-0">
                  <!--VEHICLE SECTION HEADER-->
                  <!--START VEHICLE SECTION CONTAINER-->
                  <div class="form-row ml-3 mr-0">
                    <div class="col-12 px-0">
                      <form-block v-for="(subItem, subKey) in vitem" :key="subKey+'_veh_fld_cnt'" :formdata='subItem'
                        :ref='subItem.field_name' :formIndex="vkey" class="form-group">
                        <!-- Sub section header -->
                        <div v-if="getSubsectionDisplayStatus(subItem, subKey, vitem, vkey)">
                          <div class="form-row mx-0">
                            <div class="col py-1 pl-2 my-2 ml-0 subSection-header-auto ">
                              <div role="heading" aria-level="4">{{ subItem.sub_section }}</div>
                            </div>
                          </div>
                        </div>
                        <!-- Sub sectin end -->
                      </form-block>
                    </div>
                  </div>
                  <div class="form-row py-3 mx-0 mt-4 bg-ltblue text-white rounded-bottom">
                    <div class="removedv col p-0 text-right mr-3 smaller-font-content"
                      v-if="deleteLinks[vkey] && deleteLinks[vkey].status == 'Visible'">
                      <a href="JavaScript:void(0);" tabindex="0" aria-label="remove vehicle"
                        v-if="$store.state.buttonState.quoteSummaryData && $store.state.buttonState.quoteSummaryData.quote_status !== 'Bound'"
                        @keydown.enter.prevent.stop="openRemoveModal('remove-vehicle-modal', deleteLinks[vkey].on_click)"
                        @click.prevent="openRemoveModal('remove-vehicle-modal', deleteLinks[vkey].on_click)"
                        class="text-white cursorBox">{{ deleteLinks[vkey].label }}</a>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <!-- Footer content START -->
          <div class="row no-gutters mx-0">
            <div class="col-12">
              <!--ADD DRIVER BUTTON-->
              <div class="form-row m-3" v-for="(ndData, ndKey) in pageData.add_buttons" :key="ndKey+'_add_veh_btm'"
                v-if="ndData.name === 'AddVehicle' && ndData.status !== 'Invisible'">
                <div class="col-6 pl-2"
                  v-if="$store.state.buttonState.quoteSummaryData && $store.state.buttonState.quoteSummaryData.quote_status !== 'Bound'">
                  <button type="button" @keydown.enter.prevent="" @click.prevent="addNewRule(ndData, 'Vehicle')"
                    class="add-button btn btn-outline-success d-inline-block">
                    <icon name="plus-circle" scale="1.1" class="d-block mr-1 float-left"></icon> {{ ndData.label }}
                  </button>
                </div>
              </div>
              <!--ADD DRIVER BUTTON-->
              <hr />

              <!-- bottom Instruction SECTION -->
              <div class="d-flex justify-content-center mx-auto" v-if="blurbs.formbottom.visible">
                <div class="alert alert-primary my-0 py-2 w-50" role="note">
                  <div class="row no-gutters">
                    <div class="d-inline-block pr-2">
                      <img width="25px" height="25px" src="../../../../assets/info-circle-blue.svg" alt="info">
                    </div>
                    <div class="col d-inline-block my-auto smaller-font-content" v-html="blurbs.formbottom.content">
                    </div>
                  </div>
                </div>
              </div>
              <!-- bottom Instruction SECTION END -->

              <div class="row justify-content-center mx-0 my-3" v-if="getContinueLabelName() != '' && continueEnabled">
                <div class="col-8 text-center">
                  <button type="submit" class="btn btn-primary"
                    @click.prevent="submitted">{{ getContinueLabelName() }}</button>
                </div>
              </div>
            </div>
          </div>
          <!-- Footer content END -->

        </div>
        <!-- View body END -->
      </form>
    </div>
    <dev-auto-fill :pageData="pageData"></dev-auto-fill>
    <!-- Bound Policy Alert -->
    <form-alerts
      v-if="$store.state.buttonState.quoteSummaryData && $store.state.buttonState.quoteSummaryData.quote_status === 'Bound'"
      :pageData="policyBindError" :class="{'policy-bound-alert': true, 'margin-25' : quotePanelStatus}"></form-alerts>
    <!-- Vehicle remove modal -->
    <b-modal ref="remove-vehicle-modal" hide-header hide-footer hide-header-close no-enforce-focus>
      <Trap>
        <div class="remove-confirmation-box">
          <div class="remove-modal-message mb-3">
            <div>Are you sure you want to remove this vehicle?</div>
          </div>
          <div class="remove-modal-sep mt-1 mb-1"></div>
          <div class="remove-btn-box">
            <b-button class="mt-3 remove-btn-cancel remove-cust-btn" block
              @click="closeRemoveModal('remove-vehicle-modal')">Cancel</b-button>
            <b-button class="mt-3 remove-btn-confirm remove-cust-btn" block @click="removeRule('remove-vehicle-modal')">
              Remove</b-button>
          </div>
        </div>
      </Trap>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable */

/**
 * Vehicles Interview Page is the second step in the interview process after a Named Insured is completed
 * with no user errors.
 *
 * To see the info sent from the server to render everything on this page, find 'fetchData.getPageData' and log to console the response.
 * For every field that is sent by the server, we create a <form-element> Vue component and attach to the page.
 *
 * Vee Validate is used with custom rules sent by the server to validate fields that need it.
 *
 * If there is an associated "Rule" with a field, then a POST request will be sent to the server w/the field values and the server
 * will send back what fields to update.
 * As you can see below we 'import { rulesMixin }' but the actual POST Request to the server is made in a child <form-element> component:
 * 'FormElement.vue: self.$parent.sendPost(self.apiRule.url)' and triggered by onchanges and onblurs to form elements.
 *
 * Forward progress to the next step in the Interview process (Drivers) is made by clicking the 'Save & Continue to Drivers' button.
 * If there are fields that do not meet the validation rules sent from the server, then you will not be able to progress forward in
 * the Interview Process.
 */
import stickybits from 'stickybits';
import FormBlock from '../../../presentational/FormBlock';
import FormAlerts from '../../../presentational/alerts/FormAlerts';
import { rulesMixin } from '../../../../mixins/rulesMixin';
import { pageMixin } from '../../../../mixins/pageMixin';
import InterviewNavigation from '../../shared/Navigation';
import InterviewNavigationTitle from '../../shared/NavigationTitle';
import fetchData from '../../../../services/fetchData';
import postData from '../../../../services/postData';
import common from '../../../../services/common';

export default {
  mixins: [pageMixin, rulesMixin],
  data() {
    return {
      flowType: '',
      blurbs: {
        formtop: {
          visible: false,
          content: '',
        },
        formbottom: {
          visible: false,
          content: '',
        },
        helptext: {
          visible: false,
          content: '',
        },
      },
      pageFieldsArray: [],
      deleteLinks: [],
      pageData: {
        page_name: '',
        buttons: '',
        fields: [],
        quote_summary: {},
      },
      navigatonTab: [],
      isOpen: true,
    };
  },
  methods: {
    submitForm(e) {
      e.preventDefault();
    },
    getAccordianLabel(vData, vKey) {
      return vData[vKey][0].section;
    },
    getSubsectionDisplayStatus(currentItem, currKey, vItem, vKey) {
      if (currentItem.visible && currentItem.sub_section != '' && typeof vItem[(currKey - 1)] === 'undefined') {
        return true;
      } else if (currentItem.visible && typeof vItem[(currKey - 1)] !== 'undefined' && vItem[(currKey - 1)].sub_section != currentItem.sub_section && currentItem.sub_section != '') {
        return true;
      } else {
        return false;
      }
    },
    populatePageData() {
      for (let v = 0; v < this.pageData.fields.length; v += 1) {
        const currentVeh = this.pageData.fields[v].index;
        if (!isNaN(currentVeh) && currentVeh >= 0) {
          if (!this.pageFieldsArray[currentVeh]) {
            this.pageFieldsArray.push(currentVeh);
            this.pageFieldsArray[currentVeh] = [];
          }
          this.pageFieldsArray[currentVeh].push(this.pageData.fields[v]);
        }
      }

      for (let blurb = 0; blurb < this.pageData.blurbs.length; blurb += 1) {
        this.blurbs[this.pageData.blurbs[blurb].location] = this.pageData.blurbs[blurb];
      }

      for (let btnIndex = 0; btnIndex < this.pageData.section_buttons.length; btnIndex += 1) {
        if (this.pageData.section_buttons[btnIndex].type == 'Section') {
          const remBtnArr = this.pageData.section_buttons[btnIndex].section.split('_');

          if (remBtnArr[0] === 'Vehicle') {
            if (!this.deleteLinks[remBtnArr[1]]) {
              this.deleteLinks.push(remBtnArr[1]);
            }
            this.deleteLinks[remBtnArr[1]] = this.pageData.section_buttons[btnIndex];
          }
        }
      }
    },
    refreshPageData() {
      const requestParam = {
        url: this.$store.getters.getNavLink,
      };
      fetchData.getPageData(requestParam).then((response) => {
        this.pageData = response.data;
        this.pageFieldsArray = [];
        this.deleteLinks = [];
        if (this.newTab) {
          this.newTab = [];
        }
        
        this.populatePageData();
      });
    },
  },
  components: {
    FormBlock,
    FormAlerts,
    interviewNavi: InterviewNavigation,
    interviewNaviTitle: InterviewNavigationTitle,
  },
  created() {    
    this.flowType = sessionStorage.getItem('flowType');
    const requestParam = {
      url: this.$store.getters.getNavLink,
      // url: '/pages/Vehicles/{3c463d70-41ea-4f7f-8495-40e8a21d98de}'
    };
    /**
     * Below is where we utilize our 'import fetchData' to get ALL the data needed to render this page:
     * multiple fields which could have values already in them from a previous session,
     * contents of Help/Script and Quote Summary, State of the navigation buttons, errors associated
     * with a specific field, and more.
     */
    const startTimeVal = (new Date()).getTime();
    fetchData.getPageData(requestParam).then((response) => {
      // log API response time through application into GA tool
      common.gapRecordAnalyticsGeneric(startTimeVal, 'API', response.data.page_name);
      this.pageData = response.data;

      this.populatePageData();

      this.$nextTick(() => {
        stickybits('#sub-nav', { stickyBitStickyOffset: 48 });
      });
      common.gapRecordAnalytics(response.data.page_name);
    });
    // created life cycle end here
  },
  mounted() {
    const carouselVehicleTopScrollbar = document.getElementById('carousel-vehicle-top-scrollbar');
    const carouselVehicle = document.getElementById('carousel-vehicle');
    const carouselVehicleHeadings = document.getElementById('carousel-vehicle-headings');
    carouselVehicleTopScrollbar.onscroll = () => {
      carouselVehicle.scrollLeft = carouselVehicleTopScrollbar.scrollLeft;
      carouselVehicleHeadings.scrollLeft = carouselVehicleTopScrollbar.scrollLeft;
    };
    carouselVehicle.onscroll = () => {
      carouselVehicleTopScrollbar.scrollLeft = carouselVehicle.scrollLeft;
      carouselVehicleHeadings.scrollLeft = carouselVehicle.scrollLeft;
    };
    carouselVehicleHeadings.onscroll = () => {
      carouselVehicleTopScrollbar.scrollLeft = carouselVehicleHeadings.scrollLeft;
      carouselVehicle.scrollLeft = carouselVehicleHeadings.scrollLeft;
    };

    // TODO: Don't check user agent since it is not always reliable
    // Hides horizontal scroll bar on column headings
    if (navigator.userAgent.toLowerCase().indexOf('firefox') !== -1) {
      carouselVehicleHeadings.classList.add('hide-x-scroll');
    }

    /* eslint no-undef: */
    /* eslint prefer-template:  */
  },
};
</script>

<style scoped>
.scrolling-wrapper {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
}

#carousel-vehicle-headings {
    -ms-overflow-style: none;
}

#carousel-vehicle-headings::-webkit-scrollbar { 
    display: none;
}

.scrolling-wrapper .cardItem {
  flex: 0 0 auto;
}

.scrolling-wrapper::-webkit-scrollbar {
  width: 20px;
}

.scrolling-wrapper::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
  background: #FFFFFF;
}

.scrolling-wrapper {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
}

.scrolling-wrapper .cardItem {
  flex: 0 0 auto;
}

.scrolling-wrapper .cardItem.col-md-3 {
  max-width: 400px !important;
  padding: 0 0.5rem !important;
}

#carousel-vehicle-headings .cardItem,
#form-container.fixed-top.fixed-to-nav {
  background: rgba(255, 255, 255, 0);
}

.list-item {
  display: inline-block;
  width: auto;
  height: auto;
  min-height: auto;
  float: none;
  margin: 0.25rem 0.25rem;
}

.vd-btn.list-item .delete{
  display: inline-block;
  position: absolute;
  right: -10px;
  top: -10px;
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  line-height: 1em;
  cursor: pointer;
}

.vehicle-check-polk {
  content: url('../../../../assets/check-circle-green.svg');
  display: block;
  position: absolute;
  right:-13px;
  bottom: -3px;
  width: 20px;
  height: 20px;
}

.hide-x-scroll {
  overflow-x: hidden;
}

/***header/footer information blurb***/
@media all and (max-width: 992px) {
  .alert.alert-primary{
    width: 100% !important;
  }
}

.add-button {
  text-transform: initial;
}
</style>



// WEBPACK FOOTER //
// src/components/interview/Auto/RC1/Vehicles.vue?ad840184